(function() {

    'use strict';
    angular.module('app')
        .controller('errorController', ['$scope', '$rootScope', errorController]
            );

    function errorController($scope, $rootScope) {
        $scope.model = {};

        $scope.model.errors = $rootScope.currentError.errors;
    }

})();